import React from 'react'
import {Lang} from 'yougile-lang'
import {PermissionObject} from 'yougile-model'
import {allowAllOnProject, disallowAllOnProject} from 'yougile-model'
import {allowAllOnBoard, disallowAllOnBoard} from 'yougile-model'
import {PermissionsBoardSettings} from './permissions-board-settings'
import {
  PermissionsCheckbox,
  PermissionsHeader
} from './permissions-settings-utils'

// eslint-disable-next-line max-lines-per-function
export const PermissionsProjectSettings = (props: {
  object: PermissionObject
  onChange: (obj: PermissionObject) => void
  isNew?: boolean
}) => {
  const {object, onChange} = props
  if (object.type !== 'project') {
    return null
  }
  const board: PermissionObject = {
    type: 'board',
    permissions: object.permissions.boards,
    objectId: undefined
  }
  const boardChange = (b: PermissionObject) => {
    if (b.type === 'board') {
      onChange({
        ...object,
        permissions: {...object.permissions, boards: b.permissions}
      })
    }
  }
  const allowAll = () => {
    onChange({...object, permissions: allowAllOnProject(object.permissions)})
  }
  const disallowAll = () => {
    onChange({
      ...object,
      permissions: disallowAllOnProject(object.permissions)
    })
  }
  const allowAllBoards = () => {
    onChange({
      ...object,
      permissions: {
        ...object.permissions,
        boards: allowAllOnBoard(object.permissions.boards)
      }
    })
  }
  const disallowAllBoards = () => {
    onChange({
      ...object,
      permissions: {
        ...object.permissions,
        boards: disallowAllOnBoard(object.permissions.boards)
      }
    })
  }

  return (
    <div className="flex flex-col gap-8">
      <PermissionsHeader
        title={Lang.msg.permissionsProject}
        allow={allowAll}
        disallow={disallowAll}
      />
      <PermissionsCheckbox {...props} path={['delete']} />
      <PermissionsCheckbox {...props} path={['editTitle']} />
      <PermissionsCheckbox {...props} path={['addBoard']} />
      <PermissionsHeader
        title={Lang.msg.permissionsSettingsProjectBoards}
        allow={allowAllBoards}
        disallow={disallowAllBoards}
        isSub={true}
      />
      <PermissionsBoardSettings
        isSub={true}
        object={board}
        onChange={boardChange}
      />
    </div>
  )
}
